module.exports = __webpack_public_path__ + "static/media/motic outcome2.b432ad12.png";